@if (!universalService.isMobileDevice) {
  <div class="modal fade" id="experience-now-modal" role="dialog" tabindex="-1" aria-hidden="true" [ngStyle]="{'display': showExperienceNow ? 'block' : 'none','opacity': 1, 'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content h-90">
        <div class="modal-header">
          <button type="button" class="close btn-pos" data-dismiss="modal" (click)="closePopUp()">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
        </div>
        <div class="modal-body border-bottom-0">
          <div class="experience-now-details mt-3">
            <h2>Thank you!</h2>
            <p>Your photos are being processed securely and will be ready soon.</p>
          </div>
        </div>
        <div class="modal-footer border-top-0 pt-2">
          <div class="experience-now-button">
            <button (click)="experienceNow()">Okay</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (universalService.isMobileDevice) {
  <div class="modal fade slide-in-fwd-center" id="m-experience-now-modal" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" [ngStyle]="{'display': true ? 'block' : 'none', 'opacity': 1, 'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog" role="document">
      <div class="modal-content animated bounceInUp fixed-bottom">
        <h1>Thank you!</h1>
        <div class="modal-header">
          <h6>Your photos are being processed securely and will be ready soon.</h6>
        </div>
        <div class="modal-body">
          <div class="experience-now-button pt-3">
            <button (click)="experienceNow()">Okay</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}